import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormHelperText,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

function PurchaserSelect({ value, onChange, username, fullWidth = true, sx = {}, error = false, helperText = '', required = false }) {
  const [purchasers, setPurchasers] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newPurchaserName, setNewPurchaserName] = useState('');

  useEffect(() => {
    if (username) {
      fetchPurchasers();
    }
  }, [username]);

  const fetchPurchasers = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/purchasers?username=${username}`
      );
      const data = await response.json();
      if (response.ok) {
        setPurchasers(data.purchasers || []);
      }
    } catch (error) {
      console.error('Error fetching purchasers:', error);
    }
  };

  const handleAddNewPurchaser = async () => {
    if (!newPurchaserName.trim()) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/purchasers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          purchaser_name: newPurchaserName.trim(),
        }),
      });

      if (response.ok) {
        await fetchPurchasers();
        onChange({ target: { name: 'purchaser', value: newPurchaserName.trim() } });
        setNewPurchaserName('');
        setDialogOpen(false);
      }
    } catch (error) {
      console.error('Error adding purchaser:', error);
    }
  };

  return (
    <>
      <FormControl fullWidth={fullWidth} sx={sx} error={error} required={required}>
        <InputLabel>Purchaser / Source</InputLabel>
        <Select
          name="purchaser"
          value={value || ''}
          onChange={onChange}
          label="Purchaser / Source"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {purchasers.map((purchaser) => (
            <MenuItem key={purchaser} value={purchaser}>
              {purchaser}
            </MenuItem>
          ))}
          <MenuItem
            onClick={(e) => {
              e.preventDefault();
              setDialogOpen(true);
            }}
            sx={{
              color: 'primary.main',
              fontWeight: 'bold',
              borderTop: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <AddIcon fontSize="small" />
              Add New Purchaser/Source
            </Box>
          </MenuItem>
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Purchaser/Source</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Purchaser/Source Name"
            fullWidth
            variant="outlined"
            value={newPurchaserName}
            onChange={(e) => setNewPurchaserName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleAddNewPurchaser();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleAddNewPurchaser} variant="contained">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PurchaserSelect; 